import React from 'react';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import useOWCSContent from '../../containers/owcs/useOWCSContent';
import { OWCSPageNames, OWCSPageSectionsNames } from '../../containers/owcs/owcs.constants';
import { getContentDetailsFromOWCS, getSectionsFromPage } from '../../containers/owcs/owcs.utils';
import PageDisclosure from '../pageDisclosure/pageDisclosure';

type ApyPageDisclosureProps = {
  classes: ClassNameMap;
};
function ApyDisclosure(props: ApyPageDisclosureProps) {
  const { classes } = props;
  const owcsRes = useOWCSContent(OWCSPageNames.AO_WELCOME_PAGE);
  const owcsDiscSection = getContentDetailsFromOWCS(
    getSectionsFromPage(OWCSPageSectionsNames.AO_WELCOME_DISC_SECTION, owcsRes.sections)
  )[0];

  return (
    <div data-test="apy-accounts-disclosure-container">
      {owcsDiscSection && <PageDisclosure classes={classes} discSection={owcsDiscSection} />}
    </div>
  );
}

export default ApyDisclosure;
